module.exports = __webpack_public_path__ + "static/media/Rockruff_gaussian2.b54ec598.png";